import React, { useEffect, useState } from 'react';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ExperienceSection from './sections/ExperienceSection';
import GarbaBioSection from './sections/GarbaBioSection';
import ContactSection from './sections/ContactSection';
import { mockData } from '../data/mockData';
import '../styles/Portfolio.css';

const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState(mockData);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Animation on scroll for sections
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll('.section-animate');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="portfolio-container">
      <HeroSection data={portfolioData.hero} scrollY={scrollY} />
      <GarbaBioSection data={portfolioData.garbaBio} />
      <ExperienceSection data={portfolioData.experience} />
      <AboutSection data={portfolioData.about} />
      <ContactSection data={portfolioData.contact} />
    </div>
  );
};

export default Portfolio;